var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 47,
    viewBox: "0 0 49 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8935_53392)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1349 0H32.7296L47.3781 14.0533V41.0397C47.3781 44.3167 44.5834 47 41.1642 47H16.135C12.7186 47 9.92383 44.3167 9.92383 41.0397V5.96028C9.92383 2.68331 12.7186 0 16.1349 0Z",
    fill: "#FF5F7A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7285 0L47.377 14.0533H34.3079C33.437 14.0533 32.7285 13.371 32.7285 12.5357V0Z",
    fill: "#FB4455"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.98682 20.0137H36.7335C37.484 20.0137 38.0972 20.6019 38.0972 21.3218V33.1966C38.0972 33.9165 37.484 34.5047 36.7335 34.5047H2.98682C2.23631 34.5047 1.62305 33.9165 1.62305 33.1966V21.3218C1.62305 20.6019 2.23641 20.0137 2.98682 20.0137Z",
    fill: "#FB4455"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2702 22.4355H8.72468C8.28779 22.4355 7.93359 22.7753 7.93359 23.1943V27.1965V28.1822V31.3222C7.93359 31.7413 8.28779 32.081 8.72468 32.081C9.16156 32.081 9.51576 31.7413 9.51576 31.3222V28.941H11.2701C13.1099 28.941 14.6067 27.5053 14.6067 25.7407V25.636C14.6068 23.8712 13.11 22.4355 11.2702 22.4355ZM13.0246 25.7406C13.0246 26.6685 12.2376 27.4233 11.2702 27.4233H9.51576V27.1964V23.953H11.2701C12.2375 23.953 13.0245 24.708 13.0245 25.6358L13.0246 25.7406ZM19.7832 22.4355H17.2378C16.8009 22.4355 16.4467 22.7753 16.4467 23.1943V31.3222C16.4467 31.7413 16.8009 32.081 17.2378 32.081H19.7832C21.623 32.081 23.1198 30.6453 23.1198 28.8807V25.636C23.1198 23.8712 21.623 22.4355 19.7832 22.4355ZM21.5376 28.8806C21.5376 29.8085 20.7505 30.5633 19.7832 30.5633H18.0288V23.953H19.7832C20.7505 23.953 21.5376 24.708 21.5376 25.6358V28.8806ZM26.6957 23.9531V26.0536H30.3628C30.7997 26.0536 31.1539 26.3934 31.1539 26.8124C31.1539 27.2315 30.7997 27.5712 30.3628 27.5712H26.6957V31.3222C26.6957 31.7413 26.3415 32.081 25.9046 32.081C25.4677 32.081 25.1136 31.7413 25.1136 31.3222V23.1943C25.1136 22.7753 25.4677 22.4355 25.9046 22.4355H30.9956C31.4324 22.4355 31.7866 22.7753 31.7866 23.1943C31.7866 23.6134 31.4324 23.9531 30.9956 23.9531H26.6957Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8935_53392",
    x: -2.37695,
    y: 0,
    width: 53.7559,
    height: 55,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8935_53392"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8935_53392",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/PDFIcon.074cff1730c640d03587d012de3fc296.svg";
export { ForwardRef as ReactComponent };